import React from "react";
import { CONTACT } from "../lib/constants";

export const WhatsAppFloat = () => {
  return (
    <a
      href={CONTACT.whatsappLink}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed z-50 bottom-6 right-6 md:bottom-8 md:right-8 group"
    >
      <span
        className="absolute inset-0 rounded-full"
        style={{
          background: "rgba(31,122,63,0.35)",
          animation: "ve-pulse 2.2s ease-out infinite",
        }}
      />
      <span
        className="relative flex items-center justify-center rounded-full shadow-lg overflow-hidden"
        style={{
          width: 58,
          height: 58,
          background: "#1f7a3f",
          border: "1px solid rgba(212,165,116,0.35)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
        }}
      >
        <img
          src="/whatsapp.png"
          alt="WhatsApp"
          className="w-full h-full object-contain"
          style={{ padding: "12px" }}
        />
      </span>
      <span
        className="hidden md:block absolute right-[72px] top-1/2 -translate-y-1/2 whitespace-nowrap text-xs tracking-[0.2em] uppercase opacity-0 group-hover:opacity-100 transition-opacity"
        style={{
          background: "var(--ink-700)",
          color: "var(--cream-100)",
          padding: "8px 12px",
          border: "1px solid var(--hair-strong)",
        }}
      >
        Chat on WhatsApp
      </span>
      <style>{`
        @keyframes ve-pulse {
          0% { transform: scale(1); opacity: 0.55; }
          70% { transform: scale(1.6); opacity: 0; }
          100% { transform: scale(1.6); opacity: 0; }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppFloat;